import { Theme, alpha, darken } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  sidebar: {
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    overflowY: 'auto',
    display: 'flex',
    gap: theme.spacing(3),
  },
  keywordItem: {
    padding: theme.spacing(2),
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
    transition: 'background 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.bgSecondary.main,
    },
    display: 'flex',
    justifyContent: 'space-between',
  },
  selectedKeyword: {
    background: theme.palette.bgTertiary.main,
    borderLeft: `4px solid ${theme.palette.graphColors.tertiary}`,
    fontWeight: 600,
    color: theme.palette.labraText.tertiary,
    boxShadow: 'none !important',
    '&:hover': {
      backgroundColor: `${darken(theme.palette.bgTertiary.main, 0.03)}`,
    },
  },
  rank: {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
  },
  content: {
    paddingLeft: theme.spacing(3.5),
    width: '100%',
    minWidth: 0,
    overflow: 'visible',
  },
  selfRank: {
    fontSize: '24px',
    textAlign: 'end',
  },
  selfRankChange: {
    display: 'flex',
    justifyContent: 'end',
  },
  leftHeadingWrapper: {
    display: 'flex',
    gap: theme.spacing(5),
    alignItems: 'center',
    width: '40%',
    justifyContent: 'space-between',
  },
  rankWrapper: {
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
  },
  rankingBorder: {
    borderBottom: `1px dashed ${theme.palette.dividers.light}`,
  },
  notAvilable: {
    fontSize: '12px',
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    lineHeight: '21px',
  },
  keyword: {
    fontWeight: 500,
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  keywordRank: {
    fontFamily: 'Poppins',
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.shadows.light,
  },
  keywordName: {
    fontFamily: 'Poppins',
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.labraText.tertiary,
  },
  horizontalDivider: {
    height: theme.spacing(0.125),
    width: '100%',
    backgroundColor: theme.palette.dividerV2.main,
    marginBottom: theme.spacing(2),
  },
  fullWidth: {
    width: '100%',
  },
  listWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  wrapperWidth: {
    width: theme.spacing(10),
  },
  widthRank: {
    width: '92px',
  },
  scroll: {
    height: 'calc(100vh - 250px)',
    overflowY: 'scroll',
    '&::-webkit-scrollbar-track': {
      borderRadius: '18px',
      backgroundColor: theme.palette.bgPrimary.main,
    },
    paddingRight: theme.spacing(0.5),
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar-thumb': {
      width: '8px',
      borderRadius: '18px',
      backgroundColor: theme.palette.bgSecondary.main,
    },
  },
  legendDot: {
    height: theme.spacing(1),
    width: theme.spacing(1),
    borderRadius: '50%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tooltipText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(12),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: theme.spacing(2),
    color: theme.palette.tooltipText.main,
  },
  tooltipContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  tooltipWrapper: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto',
    columnGap: theme.spacing(1.5),
    rowGap: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'start',
  },
  tooltipHeaderRow: {
    display: 'contents',
  },
  tooltipRow: {
    display: 'contents',
  },
  tooltipHeaderCell: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(11),
    fontWeight: 500,
    lineHeight: theme.spacing(2),
    letterSpacing: '0.02em',
    color: alpha(theme.palette.tooltipText.main, 0.72),
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  tooltipHeaderDivider: {
    gridColumn: '1 / -1',
    height: theme.spacing(0.125),
    backgroundColor: theme.palette.graphdivider.main,
  },
  tooltipHeaderCellNumeric: {
    textAlign: 'right',
  },
  tooltipNumericCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minHeight: theme.spacing(3),
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  tooltipLastColumn: {
    justifySelf: 'stretch',
    '& [data-testid="percentage-lable"]': {
      display: 'none',
    },
  },
  nameLegend: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    minWidth: 0,
  },
  tooltipFooter: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(11),
    fontWeight: 400,
    lineHeight: theme.spacing(2),
    color: alpha(theme.palette.tooltipText.main, 0.72),
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.graphdivider.main}`,
    textAlign: 'left',
    width: '100%',
  },
  dot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
}))
